import { render, staticRenderFns } from "./AppLabel.vue?vue&type=template&id=39b8300f&scoped=true&lang=pug&"
import script from "./AppLabel.vue?vue&type=script&lang=js&"
export * from "./AppLabel.vue?vue&type=script&lang=js&"
import style0 from "./AppLabel.vue?vue&type=style&index=0&id=39b8300f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b8300f",
  null
  
)

export default component.exports